import { gql } from "@apollo/client";

export const DIRECT_PURCHASE_CART = gql`
  mutation DirectPurchaseCart(
    $id: ID!
    $orderList: [OrderInput]!
    $userInfo: UserInfoInput!
  ) {
    directPurchaseCart(id: $id, orderList: $orderList, userInfo: $userInfo) {
      id
      date
      isNew
      status
      userDelete
      adminDelete
    }
  }
`;
export const ADD_TO_CART = gql`
  mutation AddToCart($id: ID!, $order: OrderInput!) {
    addToCart(id: $id, order: $order) {
      quoteId
      date
      isNew
      added
    }
  }
`;

export const DELETE_PRODUCT_CART = gql`
  mutation DeleteProductCart($userId: ID!, $productId: ID!) {
    deleteProductCart(userId: $userId, productId: $productId) {
      id
      orderList {
        product {
          id
          modelNum
          type
          ... on PowerQuality {
            series
          }
          ... on SPD {
            series
          }
        }
        amount
      }
    }
  }
`;

export const UPDATE_AMOUNT_CART = gql`
  mutation UpdateAmountCart($userId: ID!, $order: OrderInput!) {
    updateAmountCart(userId: $userId, order: $order) {
      id
      orderList {
        product {
          id
          modelNum
          type
          ... on PowerQuality {
            series
          }
          ... on SPD {
            series
          }
        }
        amount
      }
    }
  }
`;
export const UPDATE_QUOTE_STATUS = gql`
  mutation UpdateQuoteStatus($id: ID!, $status: QuoteStatus!) {
    updateQuoteStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;
export const DELETE_USER_QUOTES = gql`
  mutation DeleteUserQuotes($id: ID!, $ids: [ID!]!) {
    deleteUserQuotes(id: $id, ids: $ids) {
      deleted
      updated
      message
    }
  }
`;

export const REPLACE_CART = gql`
  mutation replaceCart($id: ID!, $orders: [OrderInput]!) {
    replaceCart(id: $id, orders: $orders) {
      id
      orderList {
        product {
          id
          modelNum
          type
          ... on PowerQuality {
            series
          }
          ... on SPD {
            series
          }
        }
        amount
      }
    }
  }
`;

export const PURCHASE_MY_CART = gql`
  mutation PurchaseMyCart($id: ID!, $userInfo: UserInfoInput!) {
    purchaseMyCart(id: $id, userInfo: $userInfo) {
      id
      date
      isNew
      status
      userDelete
      adminDelete
    }
  }
`;
export const DELETE_ADMIN_QUOTES = gql`
  mutation DeleteAdminQuotes($ids: [ID!]!) {
    deleteAdminQuotes(ids: $ids) {
      deleted
      updated
      message
    }
  }
`;
